import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import {
  APP_OPTIONS,
  SEARCHKIT_HOST_URL,
} from '../../config/constants';
import {
  facetAttributes,
  resultAttributes,
  searchAttributes,
  sorting,
} from './config';

// Subcomponents.
import ActiveFacets from './ActiveFacets';
import AdvancedFacets from './AdvancedFacets';
import CTA from './CTA';
import Facets from './Facets';
import Pagination from '../SearchGeneral/Pagination';
import Results from './Results';
import SearchBar from './SearchBar';
import Stats from '../SearchGeneral/Stats';
import Export from './Export';

interface SearchOcularDBSubcomponents {
  ActiveFacets: typeof ActiveFacets;
  AdvancedFacets: typeof AdvancedFacets;
  CTA: typeof CTA;
  Export: typeof Export;
  Facets: typeof Facets;
  Pagination: typeof Pagination;
  Results: typeof Results;
  SearchBar: typeof SearchBar;
  Stats: typeof Stats;
}

export type SearchOcularDBProps = Omit<SearchkitWrapperProps, 'connection' | 'indexName' | 'searchSettings'>;

// eslint-disable-next-line max-len
const SearchOcularDB: React.FC<SearchOcularDBProps> & SearchOcularDBSubcomponents = (props) => {
  const {
    className,
    children,
    routing = true,
    ...restProps
  } = props;

  const classNames = c('SearchOcularDB', className);

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexOcularDB}
      routing={routing}
      searchSettings={{
        search_attributes: searchAttributes,
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
        sorting,
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchOcularDB.ActiveFacets = ActiveFacets;
SearchOcularDB.AdvancedFacets = AdvancedFacets;
SearchOcularDB.CTA = CTA;
SearchOcularDB.Export = Export;
SearchOcularDB.Facets = Facets;
SearchOcularDB.Pagination = Pagination;
SearchOcularDB.Results = Results;
SearchOcularDB.SearchBar = SearchBar;
SearchOcularDB.Stats = Stats;

export default SearchOcularDB;
